document.addEventListener("DOMContentLoaded", function() {

  if (navigator.userAgent.includes("Edg")) {
    document.body.classList.add("edge-browser");
  }
  
    //scroll
    var totalDivs = $(".step_toolbar li").length;

    function calculateVisibleDivs() {
        var toolbarWidth = $(".step_toolbar").outerWidth();
        var itemWidth = $(".step_toolbar li").outerWidth(true);
        return Math.floor(toolbarWidth / itemWidth);
    }

    function scrollToStep(currentDiv) {
        var itemWidth = $(".step_toolbar li").outerWidth(true);
        var visibleDivs = calculateVisibleDivs();

        var scrollAmount = (currentDiv - Math.floor(visibleDivs / 2)) * itemWidth;

        if (scrollAmount < 0) scrollAmount = 0;

        $(".step_toolbar").animate({
                scrollLeft: scrollAmount,
            },
            300
        );
    }

    function activateStep(currentDiv) {
        $(".step_toolbar li").removeClass("step_active");
        $(".step_toolbar li").eq(currentDiv).addClass("step_active");
    }

    // Next button click
    $(".Next_choice").on("click", function() {

        var currentDiv = $(".step_toolbar .step_active").index();
        if (currentDiv < totalDivs - 1) {
            currentDiv++;
            activateStep(currentDiv);
            scrollToStep(currentDiv);
        }
    });

    // Previous button click
    $(".Previous_choice").on("click", function() {

        var currentDiv = $(".step_toolbar .step_active").index();
        if (currentDiv > 0) {
            currentDiv--; // Move to previous step
            activateStep(currentDiv);
            scrollToStep(currentDiv);
        }
    });

    // Direct click on list items
    $(".step_toolbar li").on("click", function() {
        $("html, body,.build_step").animate({
            scrollTop: 400
        }, 1000);
        var currentDiv = $(this).index();
        activateStep(currentDiv);
        scrollToStep(currentDiv);
    });

    //video lazy
    var lazyVideos = [].slice.call(document.querySelectorAll("video"));
    console.log(lazyVideos);
    if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy");
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }

    // home page logo section scroll js
    const scrollers = document.querySelectorAll(".scroller");

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        addAnimation();
    }

    function addAnimation() {
        scrollers.forEach((scroller) => {
            // add data-animated="true" to every `.scroller` on the page
            scroller.setAttribute("data-animated", true);

            // Make an array from the elements within `.scroller-inner`
            const scrollerInner = scroller.querySelector(".scroller__inner");
            const scrollerContent = Array.from(scrollerInner.children);

            scrollerContent.forEach((item) => {
                const duplicatedItem = item.cloneNode(true);
                duplicatedItem.setAttribute("aria-hidden", true);
                scrollerInner.appendChild(duplicatedItem);
            });
        });
    }

    // Home page product tab Section
    const tabs = document.querySelector(".wrapper");
    const tabButton = document.querySelectorAll(".tab-button");
    const contents = document.querySelectorAll(".content");
    if (tabs) {
        tabs.onclick = (e) => {
            const id = e.target.dataset.id;
            if (id) {
                tabButton.forEach((btn) => {
                    btn.classList.remove("active");
                });
                e.target.classList.add("active");

                contents.forEach((content) => {
                    content.classList.remove("active");
                });
                const element = document.getElementById(id);
                element.classList.add("active");
            }
        };
    }

    // Bottom popup close
    var videoClose =  document.querySelector(".video_popup_close");
   if(videoClose){
     videoClose.addEventListener("click", function() {
            this.closest(".video_popup").style.display = "none";
        });
   }
        

    //   var currentDiv = 0;
    // function calculateVisibleDivs() {
    //   var containerWidth = $(".step_toolbar").width();
    //   var divWidth = $(".step_toolbar li").outerWidth(true); // Get div width including margin
    //   return Math.floor(containerWidth / divWidth); // Calculate number of visible divs
    // }

    //   // reset bundle click
    var bundle_reset = document.querySelector(".bundle_reset");
    if (bundle_reset) {
        bundle_reset.addEventListener("click", function() {
            location.reload();
        });
    }

    //add button click
    document.addEventListener("click", function(event) {
        //add item
        if (event.target && event.target.matches(".add_btn")) {
            const limit_product = event.target
                .closest(".active_step_box")
                .getAttribute("data-product-limit");
            event.target.closest("li").classList.add("active_item_box");
            const countActiveItem = document.querySelectorAll(
                ".active_step_box .active_item_box"
            );
            if (countActiveItem.length <= limit_product) {
                if (countActiveItem.length == limit_product) {
                    event.target
                        .closest(".active_step_box")
                        .classList.add("stop_item_add");
                } else {
                    event.target
                        .closest(".active_step_box")
                        .classList.remove("stop_item_add");
                }
                document.querySelector(".error_mess").classList.remove("active_error");
                cartItem();
            } else {
                event.target.closest("li").classList.remove("active_item_box");
            }
        }

        //remove item
        if (event.target && event.target.matches(".Bundle_box_title .remove_btn")) {
            event.target.closest("li").classList.remove("active_item_box");
            event.target.closest("ul").classList.remove("stop_item_add");
            cartItem();
        }

        //bundle cart item remove
        if (event.target && event.target.matches(".hide_box_product")) {
            let removeItemID = event.target.getAttribute("data-id");
            if (removeItemID) {
                const items_line_check = document.querySelectorAll(".active_item_box");
                items_line_check.forEach(function(item) {
                    const dataId = item.getAttribute("data-id");
                    if (dataId == removeItemID) {
                        item.querySelector(".remove_btn").click();
                    }
                });
            }
        }
    });

    const button_next = document.querySelector(".Next_choice");
    if (button_next) {
        button_next.addEventListener("click", function() {
            scrollToBuildStep();
            let check_select_item = document.querySelectorAll(
                ".active_step_box .active_item_box"
            );
            const activeStepBox = document.querySelector(".active_step_box");
            const nextStepBox = activeStepBox.nextElementSibling;
            if (nextStepBox) {
                activeStepBox.classList.remove("active_step_box");
                nextStepBox.classList.add("active_step_box");
            }
            let step_check = document.querySelectorAll(".active_step_box");
            if (step_check) {
                let id_step = step_check[0].getAttribute("data-step");
                let bottom_step = document.querySelectorAll(".step_toolbar li");
                bottom_step.forEach(function(step) {
                    step.classList.remove("step_active");
                    let idStep = step.getAttribute("data-step");
                    if (idStep == id_step) {
                        step.classList.add("step_active");
                    }
                });
            }
            if ($(".step_toolbar li:last-child").hasClass("step_active")) {
                $(".finish_btn").show();
                $(".Next_choice").hide();
            } else {
                $(".finish_btn").hide();
                $(".Next_choice").show();
            }
        });
    }


    function scrollToBuildStep() {
        $("html, body").animate({
            scrollTop: 400
        }, 800);
    }

    const button_previous = document.querySelector(".Previous_choice");
    if (button_previous) {
        button_previous.addEventListener("click", function() {
            scrollToBuildStep();
            const activeStepBox = document.querySelector(".active_step_box");
            const prevStepBox = activeStepBox.previousElementSibling;
            if (prevStepBox) {
                activeStepBox.classList.remove("active_step_box");
                prevStepBox.classList.add("active_step_box");
            }
            let step_check = document.querySelectorAll(".active_step_box");
            if (step_check) {
                let id_step = step_check[0].getAttribute("data-step");
                let bottom_step = document.querySelectorAll(".step_toolbar li");
                bottom_step.forEach(function(step) {
                    step.classList.remove("step_active");
                    let idStep = step.getAttribute("data-step");
                    if (idStep == id_step) {
                        step.classList.add("step_active");
                    }
                });
            }
            if ($(".step_toolbar li:last-child").hasClass("step_active")) {
                $(".finish_btn").show();
                $(".Next_choice").hide();
            } else {
                $(".finish_btn").hide();
                $(".Next_choice").show();
            }
        });
    }

    //add button click
    function cartItem() {
        const items_line = document.querySelectorAll(".active_item_box");
        const cart_box_item = document.querySelector(".Bundle_item_box");
        if (items_line) {
            cart_box_item.innerHTML = "";
            let totlePrice = 0.0;
            items_line.forEach(function(item, index) {
                let itemName = item.getAttribute("data-title");
                let itemPrice = item.getAttribute("data-curr");
                let itemImg = item.getAttribute("data-img");
                let itemId = item.getAttribute("data-id");
                let itemQty = item
                    .querySelector(".remove_btn")
                    .getAttribute("data-qty");

                if (cart_box_item) {
                    cart_box_item.innerHTML += `<li class="Bundle_item_products" data-qty="${itemQty}" data-price="${itemPrice}">
                  <div class="Bundle_box_image">
                    <img class="final_bundle_image" src="${itemImg}">
                  </div>
                  <div class="Bundle_box_title">
                    <h5>${itemName}</h5>
                    <span>Qty: ${itemQty}</span>
                    <p>${itemPrice}</p>
                  </div>
                  <svg data-id="${itemId}" class="hide_box_product" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.53 9.53L14.06 13L17.53 16.47C17.6037 16.5387 17.6628 16.6215 17.7038 16.7135C17.7448 16.8055 17.7668 16.9048 17.7686 17.0055C17.7704 17.1062 17.7518 17.2062 17.7141 17.2996C17.6764 17.393 17.6203 17.4778 17.549 17.549C17.4778 17.6203 17.393 17.6764 17.2996 17.7141C17.2062 17.7518 17.1062 17.7704 17.0055 17.7686C16.9048 17.7668 16.8055 17.7448 16.7135 17.7038C16.6215 17.6628 16.5387 17.6037 16.47 17.53L13 14.06L9.53001 17.53C9.38783 17.6625 9.19978 17.7346 9.00548 17.7312C8.81118 17.7277 8.6258 17.649 8.48838 17.5116C8.35097 17.3742 8.27226 17.1888 8.26883 16.9945C8.2654 16.8002 8.33753 16.6122 8.47001 16.47L11.94 13L8.47001 9.53C8.33753 9.38782 8.2654 9.19978 8.26883 9.00548C8.27226 8.81118 8.35097 8.62579 8.48838 8.48838C8.6258 8.35097 8.81118 8.27225 9.00548 8.26882C9.19978 8.2654 9.38783 8.33752 9.53001 8.47L13 11.94L16.47 8.47C16.6122 8.33752 16.8002 8.2654 16.9945 8.26882C17.1888 8.27225 17.3742 8.35097 17.5116 8.48838C17.649 8.62579 17.7278 8.81118 17.7312 9.00548C17.7346 9.19978 17.6625 9.38782 17.53 9.53ZM25.75 13C25.75 15.5217 25.0022 17.9868 23.6012 20.0835C22.2003 22.1802 20.209 23.8144 17.8792 24.7795C15.5495 25.7445 12.9859 25.997 10.5126 25.505C8.03935 25.0131 5.76751 23.7987 3.98439 22.0156C2.20127 20.2325 0.986955 17.9607 0.494993 15.4874C0.00303191 13.0141 0.255524 10.4505 1.22054 8.12079C2.18556 5.79103 3.81976 3.79975 5.91648 2.39876C8.01321 0.997774 10.4783 0.25 13 0.25C16.3803 0.25397 19.621 1.59854 22.0112 3.98877C24.4015 6.379 25.746 9.61971 25.75 13ZM24.25 13C24.25 10.775 23.5902 8.59989 22.354 6.74984C21.1179 4.89978 19.3609 3.45784 17.3052 2.60636C15.2495 1.75487 12.9875 1.53208 10.8052 1.96617C8.62295 2.40025 6.6184 3.47171 5.04505 5.04505C3.47171 6.61839 2.40025 8.62295 1.96617 10.8052C1.53209 12.9875 1.75488 15.2495 2.60636 17.3052C3.45785 19.3609 4.89979 21.1179 6.74984 22.354C8.59989 23.5902 10.775 24.25 13 24.25C15.9827 24.2467 18.8422 23.0604 20.9513 20.9513C23.0604 18.8422 24.2467 15.9827 24.25 13Z" fill="black"></path>
                  </svg>
                </li>`;
                }
                let priceProduct = parseFloat(itemPrice * itemQty);
                priceProduct = parseFloat(priceProduct.toFixed(2));
                totlePrice += priceProduct;
            });

            let discount_value =
                document.querySelector(".discount_value").dataset.discount;
            let fivePercent = (totlePrice * discount_value).toFixed(2);
            let fivePercent_value = (totlePrice - fivePercent).toFixed(2);

            const priceFinal = document.querySelector(".Final_total_price p");
            if (priceFinal) {
                priceFinal.textContent = "$" + totlePrice.toFixed(2);
            }
            const percentFinal = document.querySelector(".percent_total_price p");
            if (percentFinal) {
                percentFinal.textContent = "$" + fivePercent_value;
            }
        }
    }

    //add to cart
    const addToCart = document.querySelector(".add_to_cart_final");
    if (button_previous) {
        addToCart.addEventListener("click", function() {
            const Product_item = [];

            let selling_plan = document.querySelectorAll(
                ".build_step .active_item_box"
            );
            if (selling_plan) {
                selling_plan.forEach(function(sellingItems) {
                    let variant_id = sellingItems
                        .querySelector(".bundle_box_cart")
                        .getAttribute("data-varid");
                    let Qty = sellingItems
                        .querySelector(".qty_action")
                        .getAttribute("data-qty");
                    var discount_code =
                        document.querySelector(".Build_box_product").dataset.discountcode;
                    Product_item.push({
                        id: variant_id,
                        quantity: Qty,
                        properties: {
                            "Discount Code": discount_code,
                        },
                    });
                });
            }

            // console.log(Product_item);

            if (Product_item.length > 0) {
                let pre_loader = document.querySelector(".itg_loader_main");

                pre_loader.style.display = "block";
                fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify({
                            items: Product_item,
                        }),
                    })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error("Error adding products to the cart");
                        }
                        return response.json();
                    })
                    .then((data) => {
                        // if (discount_code !== "undefined" && discount_code !== null) {
                        //   location.href = "/checkout?discount=" + discount_code;
                        // }
                        location.href = "/cart";
                    });
            } else {
                document.querySelector(".error_mess").classList.add("active_error");
            }
        });
    }

    // Plus Button Logic
    $(".bundle_plus").on("click", function() {
        var input = $(this).closest("li").find(".custom_quantity");
        var maxValue = input.attr("max");
        var inputValue = parseInt(input.val());
        if (inputValue < maxValue) {
            var add_qty = inputValue + 1;
            input.val(add_qty);
            var input_val = $(this).closest("li").find(".custom_quantity").val();
            if (input_val != "") {
                $(this).closest("li").find(".remove_btn").attr("data-qty", input_val);
                $(this)
                    .closest("li")
                    .find(".selling-plan-option")
                    .attr("data-qty", input_val);
            }
            cartItem();
        }
    });

    // Minus Button Logic (prevent going below minValue)
    $(".bundle_minus").on("click", function() {
        var input = $(this).closest("li").find(".custom_quantity");
        var minValue = input.attr("min");
        var inputValue = parseInt(input.val());
        if (inputValue > minValue) {
            input.val(inputValue - 1);
            var input_val = $(this).closest("li").find(".custom_quantity").val();
            if (input_val != "") {
                $(this).closest(".active_step_box").removeClass("stop_item_add");
                $(this).closest("li").find(".remove_btn").attr("data-qty", input_val);
                $(this)
                    .closest("li")
                    .find(".selling-plan-option")
                    .attr("data-qty", input_val);
            }
            cartItem();
        }
    });

    // step click
    $(document).on("click", ".step_toolbar li", function() {
        $(this).addClass("step_active").siblings().removeClass("step_active");
        var number = $(this).data("step");
        var lastNumber = $(".step_toolbar li:last-child").data("step");
        if (number != lastNumber) {
            $('.desktop_add_btn').hide();
            $('.desktop_step_btn').show();
        } else {

        }

        $(".Build_box_select .build_step").each(function() {
            var datavalue = $(this).data("step");
            if (number == datavalue) {
                $(this)
                    .addClass("active_step_box")
                    .siblings()
                    .removeClass("active_step_box");
            }
        });
        if ($(".step_toolbar li:last-child").hasClass("step_active")) {
            $(".finish_btn").show();
            $(".Next_choice").hide();
        } else {
            $(".finish_btn").hide();
            $(".Next_choice").show();
        }
    });

    //Finish btn click
    var finish_btn = document.querySelector(".finish_btn");
    if (finish_btn) {
        finish_btn.addEventListener("click", function() {
            var text_check = $(this).text();
            if (text_check == "Finish") {
                // $(".add_to_cart_final").trigger("click");
                $('.desktop_add_btn').show();
                $('.desktop_step_btn').hide();
            }
        });
    }

    // get cart data on Discount code
    $.getJSON("/cart.js", function(cart) {
        displayLineItemProperties(cart);
    });

    function displayLineItemProperties(cart) {
        // Check if the cart has items
        if (cart.items.length > 0) {
            $.each(cart.items, function(index, item) {
                if (item.properties) {
                    $.each(item.properties, function(propertyName, propertyValue) {
                        // console.log(propertyName + ": " + propertyValue);
                        if (propertyName == "Discount Code") {
                            // alert(propertyValue);
                            $(".discount_code_field").attr("value", propertyValue);
                        }
                    });
                } else {
                    console.log("No properties for this item.");
                }
            });
        } else {
            console.log("The cart is empty.");
        }
    }

    // Add External Link target="_blank"
    for (var links = document.links, i = 0, a; a = links[i]; i++) {
        if (a.host !== location.host) {
            a.target = '_blank';
        }
    }

    $('.product_options select').change(function() {
        var value = $(this).find(":selected").val();
        var price = $(this).find(":selected").attr('var-price');
        var price_without = $(this).find(":selected").attr('data-money');
        var var_image = $(this).find(":selected").attr('var-image');
        $(this).closest('.pro_list').find('.product-image').attr('src', var_image);
        $(this).closest('.Bundle_box_title').find('.add_btn').attr('data-varid', value);
        $(this).closest('.Bundle_box_title').find('.qty_action').attr('data-varid', value);
        $(this).closest('.Bundle_box_title').find('a p').text(price);
        $(this).closest('.pro_list').attr('data-curr', price_without);
    });


});